var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareBlackDesktop = function SvgShareBlackDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "share-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54159",
    transform: "translate(-241 -170)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 21269",
    width: 43,
    height: 43,
    rx: 10,
    transform: "translate(241 170)",
    "data-fill": "a",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54158"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "noun-share-1037331",
    d: "M268.565 180.379a3.546 3.546 0 0 0-3.538 3.538 3.5 3.5 0 0 0 .205 1.169l-6.476 3.759a3.535 3.535 0 1 0 .008 5.308l6.468 3.752a3.5 3.5 0 0 0-.205 1.177 3.549 3.549 0 1 0 .679-2.077l-6.279-3.633a3.5 3.5 0 0 0 0-3.752l6.279-3.633a3.535 3.535 0 1 0 2.859-5.608Z"
  })))));
};
export default SvgShareBlackDesktop;